<div class="feed">
  <h2>Feed</h2>
  <div class="feed-items">
    @for (outfitItem of outfitList; track outfitItem) {
      <app-feed-element [post]="outfitItem"></app-feed-element>
      <mat-divider></mat-divider>
    }
  </div>
</div>